import { render, staticRenderFns } from "./ComboDetail.vue?vue&type=template&id=e340bb74&"
import script from "./ComboDetail.vue?vue&type=script&lang=js&"
export * from "./ComboDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports